import { SALUTATIONS, USER_GENDER } from 'cpool-constants';

import { getTitleCase } from './getTitleCase.js';

/** `${USER_GENDER.m}` → Herr, any other gender → Frau. Returns null when missing. */
export function formatWhatsAppAgentSalutation(gender: string | null | undefined): string | null {
    if (!gender) return null;
    const salutation = gender === USER_GENDER.m ? SALUTATIONS.HERR : SALUTATIONS.FRAU;
    return getTitleCase(salutation) ?? salutation;
}
